<template>
  <div style="margin-bottom: 10px">
    <el-cascader
      :options="availableAttachments"
      v-model="valuesOfNodes"
      :style="{ width: this.computedNameWidth }"
      clearable
      filterable
      placeholder="请选择物品（可搜索）"
      :props="{ expandTrigger: 'hover' }"
    ></el-cascader>
    <span v-if="!notShowNumberInput">&nbsp;x&nbsp;</span
    ><el-input
      v-model="attachmentNumber"
      class="number-input"
      v-if="!notShowNumberInput"
    ></el-input>
    （
    <el-input
      placeholder="图标"
      v-model="attachmentIcon"
      style="width: 100px"
    ></el-input>
    ）
    <el-button
      @click="onClickRemoveBtn()"
      style="margin-left: 10px"
      icon="el-icon-delete"
      circle
      v-if="!notShowDelBtn"
    ></el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valuesOfNodes: this.value.valuesOfNodes,
      attachmentNumber: this.value.number,
      attachmentIcon: this.value.icon,
      cascaderWidth: "170px",
    };
  },

  props: {
    availableAttachments: Array,
    value: Object,
    nameWidth: String,
    notShowDelBtn: Boolean,
    notShowNumberInput: Boolean,
  },

  watch: {
    valuesOfNodes() {
      this.$emit("input", this.formattedAttachment);
    },

    /**
     * 修正数目输入框里的值
     */
    attachmentNumber() {
      let attachmentNumber = parseInt(this.attachmentNumber);
      if (isNaN(attachmentNumber)) {
        attachmentNumber = 1;
      }
      this.attachmentNumber = attachmentNumber;

      this.$emit("input", this.formattedAttachment);
    },
    attachmentIcon() {
      this.$emit("input", this.formattedAttachment);
    },
  },

  computed: {
    computedNameWidth() {
      if (this.nameWidth) {
        return this.nameWidth;
      } else {
        return "170px";
      }
    },

    /**
     * 用来返回给外部的
     */
    formattedAttachment() {
      let label = "";
      for (let item of this.availableAttachments) {
        if (item.value == this.valuesOfNodes[0]) {
          for (let child of item.children) {
            if (child.value == String(this.valuesOfNodes[1])) {
            }
            label = child.label;
            break;
          }
          break;
        }
      }

      return {
        valuesOfNodes: this.valuesOfNodes,
        label: label,
        number: this.attachmentNumber,
        icon: this.attachmentIcon,
      };
    },
  },

  methods: {
    onClickRemoveBtn() {
      // 向父组件抛出事件
      this.$emit("remove");
    },
  },
};
</script>

<style lang="scss" scoped>
.number-input {
  width: 100px;
}
</style>